const offersTourSteps = [
  {
    target: '[data-testid="offers-tabs"]',
    title: "הסטטוס של ההצעות שלכם",
    content: '**ממתינות לאישור** — הספק עדיין לא החליט. **שאושרו** — זכיתם! **שנדחו** — הספק בחר הצעה אחרת.',
    placement: "bottom",
  },
  {
    target: '.offer-rank-badge',
    title: "מיקום ההצעה שלכם",
    content: '**"מיקום ההצעה: 1"** — אתם במקום הראשון כרגע. ניתן לשפר הצעה כל עוד היא ממתינה לאישור.',
    placement: "top",
  },
  {
    target: '.offer-row .view-btns, .view-btns',
    title: "צפייה ושיפור הצעה",
    content: '**"צפייה ברכב"** — חוזרים לפרטי הרכב. **"צפייה בהצעה"** — פירוט ההצעה ואפשרות לשנות את הסכום.',
    placement: "top",
  },
];

export default offersTourSteps;
